import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AppConfig } from '../_helpers/appconfig.service';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { PayoutImportTemplate } from '../_models';

@Injectable()
export class BackFilterService {
    public customerSearch: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public invoiceSearch: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public settlementSearch: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public paymentSearch: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public notificationSearch: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public payoutAccountSearch: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public payoutSearch: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public templateSearch: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public isBrowserBackButtonPressed: BehaviorSubject<any> = new BehaviorSubject<any>(false);

    constructor() {}

    getIsBrowserBackButtonPressedSharedData(): Observable<any> {
        return this.isBrowserBackButtonPressed.asObservable();
    }
    setIsBrowserBackButtonPressedSharedData(data: any) {
        this.isBrowserBackButtonPressed.next(data);
    }

    getCustomerSearchSharedData(): Observable<any> {
        return this.customerSearch.asObservable();
    }
    setCustomerSearchSharedData(data: any) {
        this.customerSearch.next(data);
    }

    getInvoiceSearchSharedData(): Observable<any> {
        return this.invoiceSearch.asObservable();
    }
    setInvoiceSearchSharedData(data: any) {
        this.invoiceSearch.next(data);
    }

    getSettlementSearchSharedData(): Observable<any> {
        return this.settlementSearch.asObservable();
    }
    setSettlementSearchSharedData(data: any) {
        this.settlementSearch.next(data);
    }

    getPaymentSearchSharedData(): Observable<any> {
        return this.paymentSearch.asObservable();
    }
    setPaymentSearchSharedData(data: any) {
        this.paymentSearch.next(data);
    }

    getNotificationSearchSharedData(): Observable<any> {
        return this.notificationSearch.asObservable();
    }
    setNotificationSharedData(data: any) {
        this.notificationSearch.next(data);
    }

    getPayoutAccountSearchSharedData(): Observable<any> {
        return this.payoutAccountSearch.asObservable();
    }
    setPayoutAccountSharedData(data: any) {
        this.payoutAccountSearch.next(data);
    }

    getPayoutSearchSharedData(): Observable<any> {
        return this.payoutSearch.asObservable();
    }
    setPayoutSharedData(data: any) {
        this.payoutSearch.next(data);
    }

    getTemplateSearchSharedData(): Observable<any> {
        return this.templateSearch.asObservable();
    }
    setTemplateSharedData(data: any) {
        this.templateSearch.next(data);
    }
}